import TodaysGuidanceList from './todaysGuidanceList';
import IncompleteList from './incompleteList';
import UnregistList from './unregistList';
import CorrespondenceList from './correspondenceList';
import LineReceptionList from './lineReceptionList';
import SearchBox from './searchBox';
import { getMrCheck } from '../../../commonFunction/getEnv';

function DashBoardComponent(props) {
  /**
   * @typedef { import(
   *   '../../../apis/act/getActGuidancesApiTypes'
   * ).ActGuidancesGetResponse } ActGuidances
   * @typedef { import(
   *   '../../../apis/act/getIncompleteListApiTypes'
   * ).IncompleteListGetResponse } IncompleteList
   * @typedef { import(
   *   '../../../apis/act/getUnregistListApiTypes'
   * ).UnregistListGetResponse } UnregistList
   * @typedef { import(
   *   '../../../apis/act/getResponsesRecentListApiTypes'
   * ).ResponseRecentListGetResponse} ResponseRecentList
   * @typedef { import(
   *   '../../../apis/act/getLineReceptionListApiTypes'
   * ).getLineReceptionListGetResponse } LineReceptionList
   * @typedef {{
   *   actGuidances: ActGuidances;
   *   incompleteList: IncompleteList;
   *   unregistList: UnregistList;
   *   responsesRecentList: ResponseRecentList
   *   lineReceptionList: LineReceptionList
   * }} Props
   * @type { Props }
   */
  const {
    actGuidances,
    incompleteList,
    unregistList,
    responsesRecentList,
    lineReceptionList,
    query,
    setQuery,
  } = props;

  return (
    <>
      <SearchBox query={query} setQuery={setQuery} />
      <TodaysGuidanceList dataList={actGuidances} />
      <IncompleteList dataList={incompleteList} />
      <UnregistList dataList={unregistList} />
      <CorrespondenceList dataList={responsesRecentList} />
      {!getMrCheck() && <LineReceptionList dataList={lineReceptionList} />}
    </>
  );
}

export default DashBoardComponent;
